module.exports = __webpack_public_path__ + "img/alexandria_mind_flow.5860f582.png";